import createExposedPromise, {ExposedPromise} from '../createExposedPromise';

export interface RemoteId extends ExposedPromise<string> {
    sync?: string;
}

export default function createRemoteId(initialId: string | undefined): RemoteId {
    const exposedPromise = createExposedPromise<string>();
    const remoteId: RemoteId = {
        promise: exposedPromise.promise,
        resolve: (id: string) => {
            exposedPromise.resolve(id);
            remoteId.sync = id;
        },
        reject: (error: any) => {
            exposedPromise.reject(error);
        },
    };
    if (initialId !== undefined) remoteId.resolve(initialId);
    return remoteId;
}
